import { render, staticRenderFns } from "./TokenDetail.m.vue?vue&type=template&id=dee06b5e&scoped=true&"
import script from "./TokenDetail.m.vue?vue&type=script&lang=js&"
export * from "./TokenDetail.m.vue?vue&type=script&lang=js&"
import style0 from "./TokenDetail.m.vue?vue&type=style&index=0&id=dee06b5e&lang=scss&scoped=true&"
import style1 from "./TokenDetail.m.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee06b5e",
  null
  
)

export default component.exports